export const isIe11 = () => {
  //@ts-ignore
  return false || !!document.documentMode;
};
